// --- React
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

// --- Map
import MapOpenLayers from "../../components/mapOpenLayers";
import { useAtomValue } from "jotai";
import { mapInstanceAtom, mapControlsAtom } from "../../store/atoms/map";
// import MapController from "../../components/mapOpenLayers/mapController";

// --- Station
import stationSvc from "../../services/api/station";

// --- Model
import { StationItem } from "../../models/types/station";
import Annotate from "../../components/mapOpenLayers/annotate";
import { useResponsive } from "../../hooks/mediaQuery";
import { useTranslation } from "react-i18next";

export default function MapPage() {
    const mapInstance = useAtomValue(mapInstanceAtom);
    const mapControls = useAtomValue(mapControlsAtom);
    const { isXs } = useResponsive();
    const { t } = useTranslation();

    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    const [stations, setStations] = useState<StationItem[]>([]);
    const [selectedStation, setSelectedStation] = useState<StationItem | null>(null);

    useEffect(() => {
        const getAllStation = async () => {
            const response = await stationSvc.getAll({
                pageIndex: 1,
                pageSize: 10,
            });
            setStations(response.content.items);
        };
        getAllStation();
    }, []);

    useEffect(() => {
        const selectedStationId = searchParams.get("stationId");
        if (stations && selectedStationId && mapInstance && mapControls) {
            const station = stations.find((s) => s.id === Number(selectedStationId));
            if (station) {
                handleSelectStation(station)
            }
        }
    }, [stations, location.search]);

    useEffect(() => {
        if (stations && mapInstance && mapControls) {
            mapControls.pinAllStation(stations);
        }
    }, [stations, mapInstance, mapControls]);

    const handleSelectStation = (station: StationItem) => {
        setSelectedStation(station);
        mapInstance && mapControls.showStationOverlayAtCoordinate([station.longitude, station.latitude], station);
        mapInstance && mapControls.setCenter([station.longitude, station.latitude], 10);
    };

    const handleClickStation = (station: StationItem) => {
        searchParams.set("stationId", station.id.toString());
        setSearchParams(searchParams);
    };

    return (
        <div className={`grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 ${isXs ? 'gap-2' : 'gap-4'} xl:p-6 p-2 h-full`}>
            {/* Map chiếm 2 cột ở md, 3 cột ở xl */}
            <div className="relative md:col-span-2 xl:col-span-3">
                <MapOpenLayers />
                <div className="absolute z-50 bottom-0 left-0">
                    <Annotate />
                </div>
            </div>
            {/* Phần sidebar chiếm 1 cột */}
            <div className="md:col-span-1 xl:col-span-1 h-full">
                <div className="bg-white rounded-lg h-full">
                    <h1 className={`${isXs ? 'text-base p-2' : 'text-lg p-3'} font-bold text-center bg-blue-500 text-white`}>{t('station.title')}</h1><hr />
                    <div className={`${isXs ? 'px-2' : 'p-3'}`}>
                        {stations.map((station) => (
                            <div key={station.id}>
                                <div className={`${selectedStation?.id === station.id ? "bg-gray-200" : ""} p-3 hover:bg-gray-100 cursor-pointer border-b`} onClick={() => handleClickStation(station)}>
                                    <h2 className="text-base font-semibold">{station.name}</h2>
                                    <p className="text-sm text-gray-600">{station.address}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}